import type { DecodedSignedRequest } from "./types";

export const defaultMockedResponse: DecodedSignedRequest = {
  algorithm: "HMACSHA256",
  client: {
    instanceId: "_:OBCSelfService:1976:0:canvasapp",
    instanceUrl: "https://example.my.salesforce.com",
    oauthToken: "**REDACTED**",
    refreshToken: null,
    targetOrigin: "https://example.my.salesforce.com",
  },
  context: {
    user: {
      accessibilityModeEnabled: false,
      currencyISOCode: "USD",
      email: "dev.user@example.com",
      firstName: "Dev",
      fullName: "Dev User",
      isDefaultNetwork: true,
      language: "en_US",
      lastName: "User",
      locale: "en_US",
      networkId: null,
      profileId: "PROFILE_ID",
      profilePhotoUrl: "https://example--c.documentforce.com/profilephoto/USER/F",
      profileThumbnailUrl: "https://example--c.documentforce.com/profilephoto/USER/T",
      roleId: "ROLE_ID",
      siteUrl: null,
      siteUrlPrefix: null,
      timeZone: "America/New_York",
      userId: "USER_ID",
      userName: "dev.user@example.com.dev",
      userType: "STANDARD",
    },
    links: {
      chatterFeedItemsUrl: "/services/data/v31.0/chatter/feed-items",
      chatterFeedsUrl: "/services/data/v31.0/chatter/feeds",
      chatterGroupsUrl: "/services/data/v52.0/chatter/groups",
      chatterUsersUrl: "/services/data/v52.0/chatter/users",
      enterpriseUrl: "/services/Soap/c/52.0/ORG_ID",
      loginUrl: "https://example.my.salesforce.com",
      metadataUrl: "/services/Soap/m/52.0/ORG_ID",
      partnerUrl: "/services/Soap/u/52.0/ORG_ID",
      queryUrl: "/services/data/v52.0/query/",
      recentItemsUrl: "/services/data/v52.0/recent/",
      restUrl: "/services/data/v52.0/",
      searchUrl: "/services/data/v52.0/search/",
      sobjectUrl: "/services/data/v52.0/sobjects/",
      userUrl: "/USER_ID",
    },
    application: {
      applicationId: "APPLICATION_ID",
      authType: "SIGNED_REQUEST",
      canvasUrl: "http://localhost:3000",
      developerName: "OBCSelfService",
      isInstalledPersonalApp: false,
      name: "OBC Self-Service",
      namespace: "",
      options: [],
      referenceId: "REFERENCE_ID",
      samlInitiationMethod: "None",
      version: "1.0",
    },
    organization: {
      currencyIsoCode: "USD",
      multicurrencyEnabled: false,
      name: "Example Organization",
      namespacePrefix: null,
      organizationId: "ORG_ID",
    },
    environment: {
      dimensions: {
        width: "100%",
        height: "900px",
        maxWidth: "1000px",
        maxHeight: "2000px",
        clientWidth: "542px",
        clientHeight: "1000px",
      },
      displayLocation: "Aura",
      locationUrl: "https://example.lightning.force.com/lightning/cmp/c__OBCSelfServiceCanvas",
      parameters: {},
      record: {},
      referer: null,
      sublocation: null,
      uiTheme: "Theme3",
      version: { season: "SUMMER", api: "52.0" },
    },
  },
  issuedAt: -1614685283,
  userId: "USER_ID",
};
